import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  faq: drilldownData["faq"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
};
